export const presetData = {
    "shaders": {
        "selectedHandleName": "ShaderU03Schwinn",
        "selectedFrontName": "ShaderU163",
        "selectedWallName": "ShaderU899",
        "selectedShelfName": "ShaderH3157",
        "selectedBodyName": "ShaderH3157",
        "selectedLegsName": "ShaderNStGiety",
        "selectedRafixName": "Shader02Rafix",
        "selectedSupportName": "Shader02Podp"
    },
    "elements": [{
        "model": "korpus_555_4x4.gltf",
        "light": "korpus_555_4x4_light.jpg",
        "shaderName": "ShaderH3157",
        "position": {
            "x": 2.5,
            "y": 2.5
        },
        "shape": {
            "x": 4,
            "y": 4
        },
        "center": {
            "x": 0,
            "y": 91,
            "z": -0.0249996185
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": []
    }, {
        "model": "n_baza_1820x555.gltf",
        "light": "n_baza_1820x555_light.jpg",
        "shaderName": "ShaderNBaza",
        "position": {
            "x": 0,
            "y": 0
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": -9.536743e-7,
            "z": 0
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": []
    }, {
        "model": "f_1x4_AA.gltf",
        "light": "f_1x4_AA_light.jpg",
        "shaderName": "ShaderU163",
        "position": {
            "x": 1,
            "y": 2.5
        },
        "shape": {
            "x": 1,
            "y": 4
        },
        "center": {
            "x": 68.25,
            "y": 91.00001,
            "z": 28.6499939
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 1,
                "y": 2.5
            },
            "shape": {
                "x": 1,
                "y": 4
            },
            "url": "4x4_AA_1x4.png"
        },
        "bindings": [4, 5, 31]
    }, {
        "model": "ppio_555_4.gltf",
        "light": "ppio_555_4_mesh_light.jpg",
        "shaderName": "ShaderU899",
        "position": {
            "x": 1.5,
            "y": 2.5
        },
        "shape": {
            "x": 0,
            "y": 4
        },
        "center": {
            "x": 45.5,
            "y": 91,
            "z": 0.0750003815
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": []
    }, {
        "model": "zawias_L.gltf",
        "light": "zawias_L_mesh_light.jpg",
        "shaderName": "ShaderZawias",
        "position": {
            "x": 1,
            "y": 2.5
        },
        "shape": {
            "x": 1,
            "y": 4
        },
        "center": {
            "x": 88.29351862721447,
            "y": 6.700000000000003,
            "z": 21.34000287047265
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [2, 5, 31]
    }, {
        "model": "zawias_L.gltf",
        "light": "zawias_L_mesh_light.jpg",
        "shaderName": "ShaderZawias",
        "position": {
            "x": 1,
            "y": 2.5
        },
        "shape": {
            "x": 1,
            "y": 4
        },
        "center": {
            "x": 88.29351862721447,
            "y": 175.3,
            "z": 21.34000287047265
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [2, 4, 31]
    }, {
        "model": "f_1x4_DA.gltf",
        "light": "f_1x4_DA_light.jpg",
        "shaderName": "ShaderU163",
        "position": {
            "x": 4,
            "y": 2.5
        },
        "shape": {
            "x": 1,
            "y": 4
        },
        "center": {
            "x": -68.25,
            "y": 91.00001,
            "z": 28.6499939
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 4,
                "y": 2.5
            },
            "shape": {
                "x": 1,
                "y": 4
            },
            "url": "4x4_DA_1x4.png"
        },
        "bindings": [8, 9, 32]
    }, {
        "model": "ppio_555_4.gltf",
        "light": "ppio_555_4_mesh_light.jpg",
        "shaderName": "ShaderU899",
        "position": {
            "x": 3.5,
            "y": 2.5
        },
        "shape": {
            "x": 0,
            "y": 4
        },
        "center": {
            "x": -45.5,
            "y": 91,
            "z": 0.0750003815
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": []
    }, {
        "model": "zawias_P.gltf",
        "light": "zawias_P_mesh_light.jpg",
        "shaderName": "ShaderZawias",
        "position": {
            "x": 4,
            "y": 2.5
        },
        "shape": {
            "x": 1,
            "y": 4
        },
        "center": {
            "x": -88.2935183887959,
            "y": 6.700000000000003,
            "z": 21.34000406256548
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [6, 9, 32]
    }, {
        "model": "zawias_P.gltf",
        "light": "zawias_P_mesh_light.jpg",
        "shaderName": "ShaderZawias",
        "position": {
            "x": 4,
            "y": 2.5
        },
        "shape": {
            "x": 1,
            "y": 4
        },
        "center": {
            "x": -88.2935183887959,
            "y": 175.3,
            "z": 21.34000406256548
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [6, 8, 32]
    }, {
        "model": "s_555_2.gltf",
        "light": "s_555_2_komora_light.jpg",
        "shaderName": "ShaderSzuflada",
        "position": {
            "x": 2.5,
            "y": 1
        },
        "shape": {
            "x": 2,
            "y": 1
        },
        "center": {
            "x": 0,
            "y": 22.75,
            "z": 0.17500038150000002
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 1
            },
            "shape": {
                "x": 2,
                "y": 1
            },
            "url": "4x4_BA_2x1.png"
        },
        "bindings": [11, 33, 35]
    }, {
        "model": "f_2x0,5_BA.gltf",
        "light": "f_2x0,5_BA_light.jpg",
        "shaderName": "ShaderU899",
        "position": {
            "x": 2.5,
            "y": 1
        },
        "shape": {
            "x": 2,
            "y": 1
        },
        "center": {
            "x": 0,
            "y": 22.75,
            "z": 28.6499958
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 1
            },
            "shape": {
                "x": 2,
                "y": 1
            },
            "url": "4x4_BA_2x1.png"
        },
        "bindings": [10, 33, 35]
    }, {
        "model": "ppoz_555_2.gltf",
        "light": "ppoz_555_2_mesh_light.jpg",
        "shaderName": "ShaderU899",
        "position": {
            "x": 2.5,
            "y": 1.5
        },
        "shape": {
            "x": 2,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": 23.84999439648127,
            "z": 0.0750003815
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": []
    }, {
        "model": "s_555_2.gltf",
        "light": "s_555_2_komora_light.jpg",
        "shaderName": "ShaderSzuflada",
        "position": {
            "x": 2.5,
            "y": 2
        },
        "shape": {
            "x": 2,
            "y": 1
        },
        "center": {
            "x": 0,
            "y": 68.25,
            "z": 0.17500038150000002
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 2
            },
            "shape": {
                "x": 2,
                "y": 1
            },
            "url": "4x4_BB_2x1.png"
        },
        "bindings": [14, 36, 38]
    }, {
        "model": "f_2x0,5_BB.gltf",
        "light": "f_2x0,5_BB_light.jpg",
        "shaderName": "ShaderU899",
        "position": {
            "x": 2.5,
            "y": 2
        },
        "shape": {
            "x": 2,
            "y": 1
        },
        "center": {
            "x": 0,
            "y": 68.25001,
            "z": 28.6500015
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 2
            },
            "shape": {
                "x": 2,
                "y": 1
            },
            "url": "4x4_BB_2x1.png"
        },
        "bindings": [13, 36, 38]
    }, {
        "model": "ppoz_555_2.gltf",
        "light": "ppoz_555_2_mesh_light.jpg",
        "shaderName": "ShaderU899",
        "position": {
            "x": 2.5,
            "y": 2.5
        },
        "shape": {
            "x": 2,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": 69.34999439648126,
            "z": 0.0750003815
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": []
    }, {
        "model": "f_1x2_BC.gltf",
        "light": "f_1x2_BC_light.jpg",
        "shaderName": "ShaderU899",
        "position": {
            "x": 3,
            "y": 3.5
        },
        "shape": {
            "x": 1,
            "y": 2
        },
        "center": {
            "x": -22.75,
            "y": 136.5,
            "z": 28.6499977
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 3.5
            },
            "shape": {
                "x": 2,
                "y": 2
            },
            "url": "4x4_BC_2x2.png"
        },
        "bindings": [17, 18, 19, 20, 21, 34, 37]
    }, {
        "model": "f_1x2_BC.gltf",
        "light": "f_1x2_BC_light.jpg",
        "shaderName": "ShaderU899",
        "position": {
            "x": 2,
            "y": 3.5
        },
        "shape": {
            "x": 1,
            "y": 2
        },
        "center": {
            "x": 22.75,
            "y": 136.5,
            "z": 28.6499977
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 3.5
            },
            "shape": {
                "x": 2,
                "y": 2
            },
            "url": "4x4_BC_2x2.png"
        },
        "bindings": [16, 18, 19, 20, 21, 34, 37]
    }, {
        "model": "zawias_P.gltf",
        "light": "zawias_P_mesh_light.jpg",
        "shaderName": "ShaderZawias",
        "position": {
            "x": 3,
            "y": 3.5
        },
        "shape": {
            "x": 1,
            "y": 2
        },
        "center": {
            "x": -42.7935183887959,
            "y": 97.7,
            "z": 21.34000406256548
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [16, 17, 19, 20, 21, 34, 37]
    }, {
        "model": "zawias_P.gltf",
        "light": "zawias_P_mesh_light.jpg",
        "shaderName": "ShaderZawias",
        "position": {
            "x": 3,
            "y": 3.5
        },
        "shape": {
            "x": 1,
            "y": 2
        },
        "center": {
            "x": -42.7935183887959,
            "y": 175.3,
            "z": 21.34000406256548
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [16, 17, 18, 20, 21, 34, 37]
    }, {
        "model": "zawias_L.gltf",
        "light": "zawias_L_mesh_light.jpg",
        "shaderName": "ShaderZawias",
        "position": {
            "x": 2,
            "y": 3.5
        },
        "shape": {
            "x": 1,
            "y": 2
        },
        "center": {
            "x": 42.79351862721447,
            "y": 97.7,
            "z": 21.34000287047265
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [17, 16, 18, 19, 21, 34, 37]
    }, {
        "model": "zawias_L.gltf",
        "light": "zawias_L_mesh_light.jpg",
        "shaderName": "ShaderZawias",
        "position": {
            "x": 2,
            "y": 3.5
        },
        "shape": {
            "x": 1,
            "y": 2
        },
        "center": {
            "x": 42.79351862721447,
            "y": 175.3,
            "z": 21.34000287047265
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [17, 16, 18, 19, 20, 34, 37]
    }, {
        "model": "d_555_1.gltf",
        "light": "d_555_1_mesh_light.jpg",
        "shaderName": "ShaderDrazek",
        "position": {
            "x": 4,
            "y": 3.5
        },
        "shape": {
            "x": 1,
            "y": 2
        },
        "center": {
            "x": -68.25,
            "y": 168.83333333333331,
            "z": -0.0249996185
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 4,
                "y": 3.5
            },
            "shape": {
                "x": 1,
                "y": 2
            },
            "url": "4x4_DC_1x2.png"
        },
        "bindings": []
    }, {
        "model": "polka_555_2.gltf",
        "light": "polka_555_2_mesh_light.jpg",
        "shaderName": "ShaderH3157",
        "position": {
            "x": 2.5,
            "y": 3.5
        },
        "shape": {
            "x": 2,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": 113.75,
            "z": -0.0249996185
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 3.5
            },
            "shape": {
                "x": 2,
                "y": 0
            },
            "url": "4x4_BF_2x0.5.png"
        },
        "bindings": []
    }, {
        "model": "polka_555_2.gltf",
        "light": "polka_555_2_mesh_light.jpg",
        "shaderName": "ShaderH3157",
        "position": {
            "x": 2.5,
            "y": 4
        },
        "shape": {
            "x": 2,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": 136.5,
            "z": -0.0249996185
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 4
            },
            "shape": {
                "x": 2,
                "y": 0
            },
            "url": "4x4_BG_2x0.5.png"
        },
        "bindings": []
    }, {
        "model": "polka_555_2.gltf",
        "light": "polka_555_2_mesh_light.jpg",
        "shaderName": "ShaderH3157",
        "position": {
            "x": 2.5,
            "y": 3
        },
        "shape": {
            "x": 2,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": 91,
            "z": -0.0249996185
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 2.5,
                "y": 3
            },
            "shape": {
                "x": 2,
                "y": 0
            },
            "url": "4x4_BE_2x0.5.png"
        },
        "bindings": []
    }, {
        "model": "d_555_1.gltf",
        "light": "d_555_1_mesh_light.jpg",
        "shaderName": "ShaderDrazek",
        "position": {
            "x": 1,
            "y": 3.5
        },
        "shape": {
            "x": 1,
            "y": 2
        },
        "center": {
            "x": 68.25,
            "y": 168.83333333333331,
            "z": -0.0249996185
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 1,
                "y": 3.5
            },
            "shape": {
                "x": 1,
                "y": 2
            },
            "url": "4x4_AC_1x2.png"
        },
        "bindings": []
    }, {
        "model": "polka_555_1.gltf",
        "light": "polka_555_1_mesh_light.jpg",
        "shaderName": "ShaderH3157",
        "position": {
            "x": 1,
            "y": 1
        },
        "shape": {
            "x": 1,
            "y": 0
        },
        "center": {
            "x": 68.25,
            "y": 0,
            "z": -0.0249996185
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 1,
                "y": 1
            },
            "shape": {
                "x": 1,
                "y": 0
            },
            "url": "4x4_AA_1x0.5.png"
        },
        "bindings": []
    }, {
        "model": "polka_555_1.gltf",
        "light": "polka_555_1_mesh_light.jpg",
        "shaderName": "ShaderH3157",
        "position": {
            "x": 1,
            "y": 1.5
        },
        "shape": {
            "x": 1,
            "y": 0
        },
        "center": {
            "x": 68.25,
            "y": 22.75,
            "z": -0.0249996185
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "slot": {
            "position": {
                "x": 1,
                "y": 1.5
            },
            "shape": {
                "x": 1,
                "y": 0
            },
            "url": "4x4_AB_1x0.5.png"
        },
        "bindings": []
    }, {
        "model": "n_podp_h1_1820x555.gltf",
        "light": "n_podp_h1_1820_light.jpg",
        "shaderName": "ShaderNPodp",
        "position": {
            "x": 0,
            "y": 0
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": -5.25001144,
            "z": 0.0000114440918
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": []
    }, {
        "model": "n_st_giety_1820x555.gltf",
        "light": "n_st_giety_1820x555_light.jpg",
        "shaderName": "ShaderNStGiety",
        "position": {
            "x": 0,
            "y": 0
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": -9.536743e-7,
            "z": 0
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": []
    }, {
        "model": "u_03_schwinn.gltf",
        "light": "u_03_schwinn_mesh_light.jpg",
        "shaderName": "ShaderU03Schwinn",
        "position": {
            "x": 1,
            "y": 2.5
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": 50.200332599999996,
            "y": 91.00001,
            "z": 29.449672699999997
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [2, 4, 5]
    }, {
        "model": "u_03_schwinn.gltf",
        "light": "u_03_schwinn_mesh_light.jpg",
        "shaderName": "ShaderU03Schwinn",
        "position": {
            "x": 4,
            "y": 2.5
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": -50.200332599999996,
            "y": 91.00001,
            "z": 29.449672699999997
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [6, 8, 9]
    }, {
        "model": "u_03_schwinn.gltf",
        "light": "u_03_schwinn_mesh_light.jpg",
        "shaderName": "ShaderU03Schwinn",
        "position": {
            "x": 2.5,
            "y": 1
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": 34.150005300000004,
            "z": 29.4496708
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [11, 10, 35]
    }, {
        "model": "u_03_schwinn.gltf",
        "light": "u_03_schwinn_mesh_light.jpg",
        "shaderName": "ShaderU03Schwinn",
        "position": {
            "x": 3,
            "y": 3.5
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": -4.700324999999999,
            "y": 136.5,
            "z": 29.4496727
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [16, 17, 18, 19, 20, 21, 37]
    }, {
        "model": "u_03_schwinn.gltf",
        "light": "u_03_schwinn_mesh_light.jpg",
        "shaderName": "ShaderU03Schwinn",
        "position": {
            "x": 2.5,
            "y": 1
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": 0,
            "y": 11.3499994,
            "z": 29.4496708
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [11, 10, 33]
    }, {
        "model": "u_03_schwinn.gltf",
        "light": "u_03_schwinn_mesh_light.jpg",
        "shaderName": "ShaderU03Schwinn",
        "position": {
            "x": 2.5,
            "y": 2
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": -0.00000762939453,
            "y": 56.850000800000004,
            "z": 29.449672699999997
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [14, 13, 38]
    }, {
        "model": "u_03_schwinn.gltf",
        "light": "u_03_schwinn_mesh_light.jpg",
        "shaderName": "ShaderU03Schwinn",
        "position": {
            "x": 2,
            "y": 3.5
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": 4.700332599999999,
            "y": 136.5,
            "z": 29.4496727
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [17, 16, 18, 19, 20, 21, 34]
    }, {
        "model": "u_03_schwinn.gltf",
        "light": "u_03_schwinn_mesh_light.jpg",
        "shaderName": "ShaderU03Schwinn",
        "position": {
            "x": 2.5,
            "y": 2
        },
        "shape": {
            "x": 0,
            "y": 0
        },
        "center": {
            "x": -0.00000762939453,
            "y": 79.6500039,
            "z": 29.449672699999997
        },
        "rotation": {
            "x": 0,
            "y": 0,
            "z": 0,
            "w": 1
        },
        "bindings": [14, 13, 36]
    }]
};